<template>
  <div>
    <div class="top-banner" v-if="banner">
      <a v-bind:href="''+top_banner_url+''" target="_blank">
        <img :src="banner" width="100%" height="auto"/>
      </a>
    </div>
    <div class="top-banner" v-else>
      <img src="./assets/images/no-banner.png" width="100%" height="auto"/>
    </div>
    <div id="app">
      <header id="header">
          <div class="grid-container header layer1">
            <div class="logo">
              <span>Ross Noble</span>
            </div>
            <div class="nav">
              <ul>
                <li class="menu-item" v-for="item in menus">
                  <router-link :to="{ name: item.title }">
                    <span :class="['main-title', item.title.toLowerCase()]">{{ item.title }} </span>
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="mobile-nav" v-on:click="showMobileMenu()">
              <span class="menu-text">Menu</span>
              <div class="burger" v-if="!showMenu">
                <div class="burger1"></div>
                <div class="burger2"></div>
                <div class="burger3"></div>
              </div>
              <div class="burger-close" v-if="showMenu">
              </div>
            </div>
            <div class="mobile-nav-menu" v-if="showMenu">
              <ul>
                <li class="menu-item" v-for="item in menus" v-on:click="hideMobileMenu()">
                  <a :href="'#/' + item.title.toLowerCase()">
                    <span :class="['main-title', item.title.toLowerCase()]"> {{item.title}} </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </header>
    <transition name="fade" mode="out-in">
      <keep-alive include="home">
        <router-view></router-view>
      </keep-alive>    
    </transition>
      
    <div  v-show="showForm" class="overlay-grid grid-100 grid-parent">
      <div class="social-latest grid-100 grid-parent">
        <NewsletterForm @hideForm="hideForm"></NewsletterForm>
        <!-- <div class="grid-container">
          <div class="grid-100 grid-parent archive-list">
            <div class="grid-32 archive-item grid-parent"> 
              <div class="grid-100 grid-parent archive-content">
                <h1 v-html="itemData.title.rendered"></h1>
                <p v-html="itemData.content.rendered"></p> 
                <div class="archive-bottom grid-100 grid-parent">
                  <span class="archive-date">{{getDateInFormat(itemData.date)}}</span> 
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div> 
    </div> 
      
      <footer id="footer" class="layer1">
            <div class="footer grid-container grid-100 mobile-grid-100">
              <div class="footer-newsletter grid-30 mobile-grid-100">
                <div class="footer-newsletter-img" v-on:click="showFormSection()">
                  <img src="./assets/images/newsletter.svg" />
                  <span>Sign Up</span>
                </div>
                
                <!-- <div class="footer-newsletter-img">
                  <img src="./assets/images/newsletter.svg" />
                </div>
                <div class="footer-newsletter-text">
                  <span>Sign Up</span>
                </div> -->
              </div>
              <div class="copyright grid-70 mobile-grid-100" v-if="socialMediaLinks">
                <div class="social">
                  <a target="_blank" :href="facebookLink">
                    <img src="./assets/images/fb_white.svg" />
                  </a>
                  <a target="_blank" :href="twitterLink">
                    <img src="./assets/images/twitter_white.svg" />
                  </a>
                  <a target="_blank" :href="vimeoLink">
                    <img src="./assets/images/vimeo-white.svg" />
                  </a>
                </div>
                <div class="copyright-text">
                  <span>{{ copyright }}</span>
                </div>
              </div>
            </div>
            <div class="footer-extra-info grid-container grid-100 mobile-grid-100">
              <div class="cc-logo">
                <img src="./assets/images/creativecommons.png" />
              </div>
              <span class="cc-text">Images via Flickr, thanks to: @dickdotcom for 'Claw', @tambako for 'Toucan', @bertknot for 'Bushfire' &  @dirtsailor2003 for 'Hagfish'.</span>
              <a target="_blank" href="http://www.yourfavouritestory.com">
                <div class="yfs-wrapper">
                  <div class="yfs-logo"><img src="./assets/images/yfs-logo.png" /></div>
                  <span class="yfs-text">Built by Your Favourite Story</span>
                </div>
              </a>
            </div>
            
      </footer>
    </div>
  </div>
</template>

<script>
import { apiRequest, apiRequestForMenu } from "./services";
import NewsletterForm from '@/components/NewsletterForm'

export default {
  name: 'app',
  components: {
    NewsletterForm
  },
  data () {
    return {
      showMenu: false,
			showForm: false,
			socialMediaLinks: [],
      menus: [],
      banner: '',
      top_banner_url: '',
      copyright: "Copyright © 2017 Ross Noble",
    }
  },
  computed: {
    facebookLink() {
      return this.getSocialMediaLink("facebook");
    },
    vimeoLink() {
      return this.getSocialMediaLink("vimeo");
    },
    twitterLink() {
      return this.getSocialMediaLink("twitter");
		},
  },
  mounted() {
    apiRequestForMenu("menus/6")
    .then(this.receivedMenus)
    .catch(this.errorFetching);

    apiRequest("tv_configurator")
    .then(this.getbanner)
    .catch(this.errorFetching);

    apiRequest("footer-links")
      .then(this.receivedSocialMediaLinks)
      .catch(this.errorFetching);
      
    apiRequest("copyright")
      .then(this.receivedCopyrightInfo)
      .catch(this.errorFetching);
  },
  watch: {
    '$route': function () {
      if (this.$route.name === 'Home') {
        var windowH = window.innerHeight
        var windowW = window.innerWidth
        if (windowW > 600) {
          setTimeout(function () {
            document.getElementsByClassName('home-header')[0].style.height = (windowH - 100) + 'px'
          }, 50)
        }
      }
    }
  },
  methods: {
    showMobileMenu () {
      this.showMenu = !this.showMenu
    },
    hideForm () {
      this.showForm = false
    },
    hideMobileMenu () {
      this.showMenu = false
    },
    showFormSection () {
      this.showForm = true
    },
    receivedSocialMediaLinks (data) {
      this.socialMediaLinks = data;
    },
    getSocialMediaLink (name) {
      const obj = this.socialMediaLinks.find(link => link.slug === name) || {};
      return obj.social_link;
		},
		receivedMenus (data) {
			this.menus = data.items;
    },
    getbanner (data) {
      this.banner = data[0].top_image.guid;
      this.top_banner_url = data[0].top_banner_url;
    },
    receivedCopyrightInfo (data) {
      this.copyright = data[0].title.rendered;
    },
    errorFetching (error) {
      console.warn(error);
    },
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 60px; */
}
</style>

<style>
.fade-enter-active {
  transition: opacity 0.5s ease;
}
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter, .fade-leave-active {
  opacity: 0
}
.child-view {
  position: absolute;
  transition: all 0.5s cubic-bezier(.55,0,.1,1);
}
.slide-left-enter, .slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}
.slide-left-leave-active, .slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}
</style>

<style lang="scss" type="text/scss">
@import 'css/style.scss';
</style>


// WEBPACK FOOTER //
// App.vue?26dcfcfc